import { useQuery } from "@tanstack/react-query";
import { fetchUser } from "../api/fetch-user";

export const CURRENT_USER_QUERY_KEY = "currentUser";

export function useCurrentUser() {
  return useQuery({
    queryKey: [CURRENT_USER_QUERY_KEY],
    queryFn: async () => {
      const user = await fetchUser();
      if (import.meta.env.DEV && new URLSearchParams(window.location.search).has("asClient")) {
        return { ...user, isStaff: false };
      }
      return user;
    },
  });
}
